// import userStorage from "../common/userStorage";
// import axios from "axios";
// const { REACT_APP_API_BASE_URL } = process.env;

// const useRefreshToken = () => {
//   const refresh = async () => {
//     const authInfo: any = userStorage.getAuthInfo();
//     let formData = new FormData();
//     formData.append("refresh_token", authInfo?.refreshToken);
//     const response = await axios({
//       method: "post",
//       url: `${REACT_APP_API_BASE_URL}/refresh_token`,
//       data: formData,
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//     });
//     userStorage.updateAuthToken({
//       accessToken: response?.data?.access_token,
//       refreshToken: response?.data?.refresh_token,
//       name: authInfo?.name,
//     });
//     return response.data;
//   };
//   return refresh;
// };

// export default useRefreshToken;


import { useNavigate } from "react-router-dom";
import userStorage from "../common/userStorage";
import axios from "axios";

const { REACT_APP_API_BASE_URL } = process.env;

const useRefreshToken = () => {
  const navigate = useNavigate();          // ⬅️ router-dom v6 hook

  const refresh = async () => {
    try {
      const authInfo: any = userStorage.getAuthInfo();
      const formData = new FormData();
      formData.append("refresh_token", authInfo?.refreshToken);

      const { data } = await axios.post(
        `${REACT_APP_API_BASE_URL}/refresh_token`,
        formData,
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );

      userStorage.updateAuthToken({
        accessToken: data.access_token,
        refreshToken: data.refresh_token,
        name: authInfo?.name,
      });

      return data;                         // success
    } catch (err: any) {
      // 🔐 If the refresh token is invalid/expired (or any other error)…
      if (err?.response?.status === 401) {
        userStorage.revoveAllInfo();       // remove stale tokens
      }
      navigate("/login", { replace: true });
      throw err;                           // still let callers know it failed
    }
  };

  return refresh;
};

export default useRefreshToken;
